import * as React from 'react';
import { Modal, Button, Label, Input, Form } from 'semantic-ui-react';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus } from '../../api';

class State {
    oldPassword: any;
    newPassword: any;
    confirmPassword: any;
    showError: boolean;
    errorText: string;
}

interface Props {
    showModal: boolean;
    handlePasswordModalClose: any;
}

export default class ChangePasswordWindow extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            showError: false,
            errorText: ''
        });
    }

    handleErrorModalClose() {
        this.setState({
            showError: false
        });
    }

    render() {

        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        return (
            <OAuth.Context>{ (oauth: OAuthClientStatus) => (
                <React.Fragment>
                <Modal
                    open={this.props.showModal}
                    onClose={this.props.handlePasswordModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Change Password</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                <Label className="filterPanelLabel">
                                    Current Password:
                                </Label>
                                <Input
                                    type="password"
                                    value={this.state.oldPassword}
                                    onChange={(event, data) => this.setState({oldPassword: data.value})}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Label className="filterPanelLabel">
                                    New Password:
                                </Label>
                                <Input
                                    type="password"
                                    value={this.state.newPassword}
                                    onChange={(event, data) => this.setState({newPassword: data.value})}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Label className="filterPanelLabel">
                                    Confirm Password:
                                </Label>
                                <Input
                                    type="password"
                                    value={this.state.confirmPassword}
                                    onChange={(event, data) => this.setState({confirmPassword: data.value})}
                                />
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.checkPassword(oauth, oauth.clientID, oauth.clientSecret)}>
                            Change
                        </Button>
                        <Button className="filterPanel-secondary-btn modal-button-padding" onClick={this.props.handlePasswordModalClose}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.showError}
                    onClose={this.handleErrorModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Error</Modal.Header>
                    <Modal.Content>
                        {this.state.errorText}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn" onClick={() => this.handleErrorModalClose()}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
                </React.Fragment>
            )}</OAuth.Context>

        );
    }
    checkPassword(oauth: OAuthClientStatus, username: any, currentPassword: any) {
        // tslint:disable-next-line:variable-name
        const clientID = Buffer.from(username as string, 'base64').toString();
        const clientSecret = Buffer.from(currentPassword as string, 'base64').toString();
        let __this = this;
        if (this.state.oldPassword !== clientSecret) {
            this.setState({
                showError: true,
                errorText: 'Incorrect current password!'
            });
        } else if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({
                showError: true,
                errorText: 'Passwords don\'t match!'
            });
        } else {
            // @ts-ignore
            oauth.updateUserPwd(clientID, clientSecret, this.state.newPassword)
                .then(function (response: AxiosResponse) {
                    if (response) {
                        __this.props.handlePasswordModalClose();
                    } else {
                        // tslint:disable-next-line:no-console
                        console.log('Change password error, got ', response);
                        __this.props.handlePasswordModalClose();
                    }
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('Change password error, got: ', error);
                });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/changePassword.tsx